<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="graphics-symbol" aria-hidden="true">
    <title>Menu</title>
    <path
      fill="currentColor"
      d="M1.3 2.7c-.3 0-.7.1-.9.4-.3.2-.4.5-.4.9s.1.7.4.9c.2.3.6.4.9.4h21.3c.4 0 .7-.1.9-.4.4-.2.5-.5.5-.9s-.1-.7-.4-.9c-.2-.3-.6-.4-.9-.4H1.3zM0 12c0-.4.1-.7.4-.9.3-.2.6-.4.9-.4h21.3c.4 0 .7.1.9.4s.5.5.5.9-.1.7-.4.9c-.2.3-.6.4-.9.4H1.3c-.4 0-.7-.1-.9-.4-.3-.2-.4-.5-.4-.9zm0 8c0-.4.1-.7.4-.9.3-.2.6-.4.9-.4h21.3c.4 0 .7.1.9.4s.5.5.5.9-.1.7-.4.9c-.2.3-.6.4-.9.4H1.3c-.4 0-.7-.1-.9-.4-.3-.2-.4-.5-.4-.9z"
    />
  </svg>
</template>
